import { useCallback, useEffect, useRef, useState } from 'react';
import { useLazyGetCloudAttributesQuery } from '../../../../api';

export const useCloudAttributes = (cloudAccount, onLoaded) => {
    const [fetchAttributes, { isLoading: loadingAttributes }] = useLazyGetCloudAttributesQuery();
    const [initialLoading, setInitialLoading] = useState(true);
    const [loadingError, setLoadingError] = useState(null);

    const onLoadedRef = useRef(onLoaded);
    useEffect(() => {
        onLoadedRef.current = onLoaded;
    });

    const loadCloudAttributes = useCallback(async () => {
        if (!cloudAccount) {
            return;
        }
        setInitialLoading(true);
        setLoadingError(null);
        try {
            const result = await fetchAttributes({
                cloudAccountId: cloudAccount.id,
                params: { summary: true },
            }).unwrap();
            onLoadedRef.current?.(result);
        } catch (error) {
            setLoadingError(error);
        } finally {
            setInitialLoading(false);
        }
    }, [cloudAccount, fetchAttributes]);

    useEffect(() => {
        loadCloudAttributes();
    }, [loadCloudAttributes]);

    return { initialLoading, loadingError, loadCloudAttributes, fetchAttributes, loadingAttributes };
};

